<template>
  <div>

    <h2>{{ $t('title.' + action + '.switch-group') }}</h2>

    <el-row :gutter="40">

      <el-col :span="24" :md="18" :lg="12">

        <data-form
          model="switch-groups"
          :entity="switchGroup"
          :fields="fields"
          :beforeSubmit="beforeSubmit"
          :after-submit="afterSubmit"
        >

          <h4>{{ $t('related-switches') }}</h4>

          <data-table
            model="switches"
            :columns="['controllerName', 'name']"
            :isSelected="isSwitchSelected"
            @selection-change="switchSelectChanged"/>

            </data-form>

        </el-col>

    </el-row>

  </div>
</template>

<script>
export default {
  name: 'switch-group-details',
  data () {
    return {
      newRelatedSwitchIds: [],
      fields: {
        'name': {
          type: 'text',
          rules: [{ required: true }, { max: 80 }]
        },
        'description': {
          type: 'textarea',
          rules: [{ required: true }, { max: 80 }]
        }
      }
    }
  },
  computed: {
    switchGroup () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true, relatedSwitchIds: [] }
      }

      return this.$store.getters['switch-groups/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.switchGroup.new ? 'create' : 'edit'
    }
  },
  methods: {
    beforeSubmit (model) {
      model.newRelatedSwitchIds = this.newRelatedSwitchIds
    },
    afterSubmit () {
      this.$router.back()
    },
    isSwitchSelected (xswitch) {
      return this.switchGroup.relatedSwitchIds.includes(xswitch.id)
    },
    switchSelectChanged (selectedSwitches) {
      this.newRelatedSwitchIds = selectedSwitches.map(c => c.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SwitchGroupDetails.vue?082a98ba